<div (click)="closeDialog()" class="ns-close-button"></div>
<div class="scrollable">
  <div *ngFor="let key of impactAxis">
    <div class="axis-logo">
      <img loading="lazy" src="/assets/icons/north_star/{{ key }}.svg" alt="{{ key }}">
    </div>
    <div class="axis-title">{{ "PREFERENCES_POPUP_1." + key + "_preferencespopup1" | translate | capitalize }}</div>
    <div class="project-wrapper" *ngFor="let project of sortedProjects[key]">
      <div class="project-image" [style.backgroundImage]="'url(' + project.picture_thumbnail + ')'"></div>
      <div class="project-right-part">
        <div class="project-kpi" *ngIf="!project.square_meters">
          {{ roundImpact(project.progress) }} {{ project.main_kpi_unit[currentLanguage] }}
        </div>
        <div class="project-kpi" *ngIf="project.square_meters">
          {{ roundImpact(project.progress * 10000) }} {{ project.square_meters_unit[currentLanguage] }}
        </div>
        <div class="project-title" (click)="goToProject(project.slug)">
          {{ project.name[currentLanguage] }}
        </div>
      </div>
    </div>
  </div>
</div>
